


























import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Play extends Vue {
  get playUrl(): string {
    return `/play/?appid=${this.$route.params.game}&cgtoken=${this.$store.direct.getters.authentication.jwt}&eula=true`;
  }

  init(): void {
    var body = document.body;
    body.classList.add("no-handle-notch");
  }

  reset(): void {
    var body = document.body;
    body.classList.remove("no-handle-notch");
  }

  activated(): void {
    this.init();
  }

  deactivated(): void {
    this.reset();
  }

  mounted(): void {
    this.init();
  }

  beforeDestroy(): void {
    this.reset();
  }
}
